/* eslint-disable */
import 'jquery';

const desktop_nav_search = (function() {
  
  const $form = $('.DesktopNav-search');
  const $input = $form.find('input[type="text"]');
  const $submit = $form.find('input[type="submit"]');

  let header_can_animate = true; // if false, pauses animation if another animation is occuring (changed by animate_header_state)
  let header_animation_queue = []; // holder array for delayed animations

  // Setup interactive handlers
  const init = () => {
    $('.DesktopNav-search, .DesktopNav-search svg, .DesktopNav-search input[type="submit"]').on('click', function( e ) {
      handle_search_click( e );
    });
    $('body').focusin(function(){ 
      handle_focus_change();
    });
    $form.focusout(function(){
      handle_focus_change();
    });
  };

  // Handlers
  const handle_search_click = ( e ) => {
    // If the search form is clicked and there's no value in the text input,
    // give the text input focus to expand the form.
    const search_val = $input.val();
    if ( typeof search_val === 'undefined' || search_val.length === 0 ) {
      e.preventDefault();
      $input.focus();
    }
  };

  const handle_focus_change = () => {
    // When the search form has focus, animate it to its open state. When it
    // doesn't have focus, animate it to its closed state.
    const $items_to_hide = $('[data-hide-on-search="true"]');
    if ( $form.is(':focus-within') ) {
      animate_header_state( 'open-search' );
    } else {
      animate_header_state( 'close-search' );
    }
  };

  // Animation
  const animate_header_state = ( state ) => {
    // Perform the animation by adding/removing helper classes. Since this 
    // animation includes a timeout, it runs the risk of overwriting itself
    // mid-animation if a user is moving quickly which can result in visual
    // errors. Thus, if an animatin is currently in process we defer any 
    // additional animation state changes and add them to an array. We then 
    // recursively call this function with the defered animations one at a 
    // time until there are none left.
    if ( header_can_animate ) {
      header_can_animate = false;
      const $items_to_hide = $('[data-hide-on-search="true"]');
      if ( state === 'open-search' ) {
        $items_to_hide.addClass('-hide-for-search');
        setTimeout( () => {
          $form.addClass('-open');
          header_can_animate = true;
          // If there's a queue, run function again w/ next queue item
          if ( header_animation_queue.length > 0 ) {
            animate_header_state( header_animation_queue[0] );
            header_animation_queue.splice(0, 1); // remove the animation we just called from the queue
          }
        }, 150);
      }
      if ( state === 'close-search' ) {
        $form.removeClass('-open');
        setTimeout( () => {
          $items_to_hide.removeClass('-hide-for-search');
          header_can_animate = true;
          // If there's a queue, run function again w/ next queue item
          if ( header_animation_queue.length > 0 ) {
            animate_header_state( header_animation_queue[0] );
            header_animation_queue.splice(0, 1); // remove the animation we just called from the queue
          }
        }, 250);
      }
    } else {
      // Cannot animate, defer this animation and add it to the queue to process later
      header_animation_queue.push( state );
    }
  };

  return {
    init: init,
  }
})();

$(document).ready(function() {
  desktop_nav_search.init();
});
/* eslint-enable */


// WEBPACK FOOTER //
// ./scripts/components/desktop_nav_search.js